import { CURRENCY } from '../../../utils/currency'

export const LIST_SETTINGS = {
  LANGUAGE: 'Language',
  TIME_ZONE: 'Time zone',
  DEFAULT_CURRENCY: 'Default currency',
  FONT_SIZE: 'Font size',
}

export const LIST_LANGUAGE = [
  { title: 'settingPreferences.VIETNAMESE', value: 'vi' },
  { title: 'settingPreferences.ENGLISH', value: 'en' },
]

export const LIST_CURRENCY = Object.keys(CURRENCY).map((key) => ({
  value: CURRENCY[key],
  title: key,
}))

export const LIST_FONT_SIZES = [
  { title: 'settingPreferences.SMALL', value: 'Small' },
  { title: 'settingPreferences.MEDIUM', value: 'Medium' },
  { title: 'settingPreferences.LARGE', value: 'Large' },
]
